import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import I18n from 'i18n-react'

// components
import TilesList from '../Components/_ui/TilesList.js'

// redux
import DomexActions from '../Redux/DomexRedux'
import GeneralActions from '../Redux/GeneralRedux'
import { SCREENS } from '../Redux/NavigationRedux'

class LiabilityDetailContainer extends React.Component {
	static propTypes = {
		domexSetMaxLiability: PropTypes.func.isRequired,
		maximumLiability: PropTypes.array.isRequired,
		maximumLiabilityIndex: PropTypes.number.isRequired,
		onSetScreenIsValid: PropTypes.func.isRequired,
		screenValidateSig: PropTypes.array.isRequired,
	}

	componentWillReceiveProps = (nextProps) => {
		if (nextProps.screenValidateSig[SCREENS.LIABILITY_DETAIL].validate === true) {
			const valid = this.handleValidate()
			nextProps.onSetScreenIsValid(SCREENS.LIABILITY_DETAIL, valid)
		}
	}

	handleValidate = () => this.props.maximumLiabilityIndex >= 0

	handleSetMaxLiability = (index) => {
		this.props.domexSetMaxLiability(index)
	}

	render() {
		return (
			<div>
				<h3>{I18n.translate('general.liabilityDetailTitle')}</h3>
				<p>{I18n.translate('general.liabilityDetailDescription')}</p>
				<TilesList
					activeIndex={this.props.maximumLiabilityIndex}
					isMoney
					name='maximumLiability'
					onChange={this.handleSetMaxLiability}
					tiles={this.props.maximumLiability}
				/>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	maximumLiability: state.domex.maximumLiability,
	maximumLiabilityIndex: state.domex.maximumLiabilityIndex,
	screenValidateSig: state.general.screenValidateSig,
})

const mapDispatchToProps = {
	domexSetMaxLiability: DomexActions.domexSetMaxLiability,
	onSetScreenIsValid: GeneralActions.onSetScreenIsValid,
}

export default connect(mapStateToProps, mapDispatchToProps)(LiabilityDetailContainer)
